import { AbstractControl, FormArray, FormGroup, ValidatorFn, Validators } from '@angular/forms';

import { LIMITS } from './validation.criteria';
import { PATTERN } from './patterns';

export const CustomValidators = {
  whiteSpace(control: AbstractControl) {
    if (typeof control.value !== 'number') {
      const value = control.value || '';
      const isWhitespace = (value.trim().length !== value.length) && (value.trim().length === 0);
      return !isWhitespace ? null : { whiteSpace: true };
    }
    return null;
  },
  get name(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.required,
      // Validators.pattern(PATTERN.text),
      Validators.maxLength(LIMITS.titleMaxLength),
      Validators.minLength(LIMITS.titleMinLength)
    ];
  },

  get Keyname(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.maxLength(LIMITS.titleMaxLength),
      Validators.minLength(LIMITS.titleMinLength)
    ];
  },
  get whiteSpaceValidation(): ValidatorFn[] {
    return [
      this.whiteSpace
    ]
  },
  get description(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.required,
      Validators.maxLength(LIMITS.descriptionMaxLength),
      Validators.minLength(LIMITS.descriptionMinLength)
    ];
  },
  get email(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.email,
      Validators.required,
      Validators.pattern(PATTERN.email),
    ];
  },
  get customName(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.required,
      // Validators.pattern(PATTERN.excludeDigits),
      Validators.maxLength(50),
      Validators.minLength(3)
    ];
  },
  get websiteUrl(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.pattern("^(https?|ftp)://.*$"),
    ]
  },
  get password(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.required,
      Validators.pattern(PATTERN.password),
      Validators.minLength(6),
      Validators.maxLength(20)
    ];
  },
  get passwordNoValidation(): ValidatorFn[] {
    return [
      this.whiteSpace,
      Validators.required,
      // Validators.pattern(PATTERN.password),
      Validators.minLength(6),
      Validators.maxLength(70)
    ];
  },
  number(control: AbstractControl): { [key: string]: any } {
    if (isNaN(parseFloat(control.value))) {
      return { number: true };
    }
    return null;
  },
  minLength(requiredLength: number) {
    return (control: AbstractControl) => {
      if (control.value) {
        const value = control.value.toString();
        if (value.length < requiredLength) {
          return { minlength: { requiredLength } };
        }
      }
      return null;
    };
  },
  maxLength(requiredLength: number) {
    return (control: AbstractControl) => {
      if (control.value) {
        const value = control.value.toString();
        if (value.length > requiredLength) {
          return { maxlength: { requiredLength } };
        }
      }
      return null;
    };
  },
  get phone(): ValidatorFn[] {
    return [
      this.number,
      this.minLength(7),
      this.maxLength(15)
    ];
  },
  get Price(): ValidatorFn[] {
    return [
      this.number,
      this.minLength(1),
      this.maxLength(14)
    ]
  },
  get mobileNo(): ValidatorFn[] {
    return [
      this.number,
      Validators.required,
      this.minLength(7),
      Validators.pattern(PATTERN.phone),
      this.maxLength(15)
    ];
  },
  get zipCode(): ValidatorFn[] {
    return [
      this.number,
      this.minLength(5),
      Validators.pattern(PATTERN.phone),
      this.maxLength(10)
    ];
  },
  match(field: string, parentControl?: FormGroup | FormArray): ValidatorFn {
    return this.compare(field, 'MATCH', parentControl)((a, b) => a === b);
  },
  lowerThan(field: string, label?, parentControl?: FormGroup | FormArray): ValidatorFn {
    return this.compare(field, 'LOWER', label || field, parentControl)((a, b) => a <= b);
  },
  higherThan(field: string, label?, parentControl?: FormGroup | FormArray): ValidatorFn {
    return this.compare(field, 'HIGHER', label || field, parentControl)((a, b) => a >= b);
  },
  compare(field: string, type: 'MATCH' | 'LOWER' | 'HIGHER', label, parentControl?: FormGroup | FormArray) {
    return (fn: (a: any, b: any) => boolean) => {
      return (control: AbstractControl) => {
        if (control.value || control.value === 0) {
          const parent = parentControl ? parentControl : control.parent;
          if (parent) {
            const matchControl: AbstractControl = parent.controls[field];
            if (!matchControl) {
              throw (new Error(`Match Control [${label}] not found on parent control.`));
            }
            if (matchControl.dirty && !fn(control.value, matchControl.value)) {
              return {
                compare: {
                  field: label,
                  type
                }
              };
            }
          }
        }
      };
    };
  },
  url(control: AbstractControl) {
    const regForUrl = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (!regForUrl.test(control.value)) {
      return { url: true };
    }
    return null;
  }
};
